import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { visualizerActions, uiActions } from "../../store";
import styles from "./PackagesList.module.css";
import selected from './assets/selected.svg';

export default function PackagesList() {
    const urlParams = useParams();
    const currentPackageId = urlParams.packageName;
    const [selectedPackageId, setSelectedPackageId] = useState(currentPackageId);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(visualizerActions.setActivePackage(currentPackageId));
    }, [dispatch, currentPackageId]);

    const packageData = useSelector(state => state.visualizer.packagesData);
    
    const handleClick = (thisPackage) => {
        dispatch(visualizerActions.setActivePackage(thisPackage.id));
        setSelectedPackageId(thisPackage.id);
        dispatch(uiActions.setVizLoading(true));
        document.getElementById('chamViz').load("Demo\\Cambridge_Homes\\Kitchen(qfactor=(10,4))", thisPackage.sel);
    };

    const packages = [];
    if (packageData['packages'] != null) {
        packageData['packages'].forEach((thisPackage) => {
            packages.push(
                <li 
                    key={thisPackage.id} 
                    onClick={() => handleClick(thisPackage)} 
                    className={thisPackage.id === selectedPackageId ? styles.active : ''}
                >
                    <img alt={thisPackage.name} src={"https://renderfarm1.chameleonpower.com/cham/getImage.ashx?specifier=Demo\\Cambridge_Homes\\Kitchen(qfactor=(10,4))&sel=" + thisPackage.sel + "&size=300"} width="100" height="100"/>
                    <img alt={thisPackage.name} src={selected} className={styles.selectedImg} width="96" height="69" />
                </li>
            );
        });
    }

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.header}>
                    <p>Choose a package</p>
                </div>
                <div className={styles.packages}>
                    <ul>
                        {packages}
                    </ul>
                </div>
            </div>
        </div>
    );
}
